import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activeJournalCategory: null,
    activeJournalProgram: null,
    client: null,
    clientSlug: null,
    latestFromRoute: { matched: [] },
    userData: JSON.parse(localStorage.getItem('userData')),
    programs: JSON.parse(localStorage.getItem('programs')),
    notificationPreferences: JSON.parse(localStorage.getItem('notificationPreferences')) || { enabled: false, time: '08:00' },
  },
  mutations: {
    activeJournalCategory(state, value) {
      state.activeJournalCategory = value;
    },
    activeJournalProgram(state, value) {
      state.activeJournalProgram = value;
    },
    client(state, value) {
      state.client = value;
      localStorage.setItem('client', JSON.stringify(value));
    },
    setClientSlug(state, value) {
      state.clientSlug = value;
      localStorage.setItem('clientSlug', value);
    },
    latestFromRoute(state, value) {
      state.latestFromRoute = value;
    },
    userData(state, value) {
      state.userData = value;
      localStorage.setItem('userData', JSON.stringify(value));
    },
    programs(state, value) {
      state.programs = value;
      localStorage.setItem('programs', JSON.stringify(value));
    },
    notificationPreferences(state, value) {
      state.notificationPreferences = value;
      localStorage.setItem('notificationPreferences', JSON.stringify(value));
    },
  },
  actions: {
  },
  modules: {
  },
});
